'use strict'

export const mobileRegExp =
  /^1(3[0-9]|4[01456879]|5[0-3,5-9]|6[2567]|7[0-8]|8[0-9]|9[0-3,5-9])\d{8}$/

export function validMobile(value) {
  return mobileRegExp.test(value)
}

export const emailRegExp =
  /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/

export function validEmail(value) {
  return emailRegExp.test(value)
}

export const isMobile = () => {
  // 1. 先看 UA
  const ua = navigator.userAgent || navigator.vendor || window.opera
  const isPhone = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(ua)

  // 2. 再看视口宽度（平板横屏时 UA 仍叫 iPad，但宽度>768）
  const isSmallScreen = window.innerWidth <= 768

  return isPhone || isSmallScreen
}

export function useDeviceType() {
  let deviceType

  const ua = navigator.userAgent
  const width = window.innerWidth

  // 判断是否是移动设备（手机或平板）
  const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/u.test(ua)

  // 更精确地区分
  if (isMobile) {
    // 通过屏幕宽度 + UA 判断是否是平板
    if (/(iPad|Android(?!.*Mobile))/i.test(ua) || width >= 768) {
      // 常见平板屏幕宽度大于 768px
      deviceType = 'iPad'
    } else {
      deviceType = 'mobile'
    }
  } else {
    deviceType = 'pc'
  }

  return deviceType
}
